export const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
export enum loginScreens {
  Phone = 'phone',
  LoginPassword = 'loginPassword',
  Otp = 'otp',
  UpdatePassword = 'updatePassword',
  Google = 'Google',
  Facebook = 'Facebook',
}
export const qrPayLater = true;
export const message = {
  INVALID_TENANT: 'Business not found!',
  WELCOME_BACK: 'Welcome back!',
  BLOCK_LOCATION: 'GeoLocation Blocked', //user block the location in browser
  MODIFIERS_QUANTITY_EXCEEDED: 'Modifiers Quantity Exceeded',
  RESTAURANT: {
    CLOSED: 'Restaurant Closed',
  },
  ITEM: {
    UNAVAILABLE: 'Item Unavailable',
    OUT_OF_STOCK: 'Out of Stock',
    OUT_OF_STOCK_DESC: 'Some items in your cart are unavailable. Please remove them to proceed to checkout.',
  },
  WARNING: {
    LOYALTY_LIMIT: 'You can redeem only 1 item per order',
    MODIFIER_SELECTION_COMPLETION: 'Please complete modifier selections',
  },
  DEAL: {
    MIN_SPEND: 'Minimum spend remaining',
    BUY_CRITERIA_NOT_MET: 'Complete Buy Items selection',
    GET_CRITERIA_NOT_MET: 'Complete Get Items selection',
    GET_GIFT_CRITERIA_NOT_MET: 'Complete Gift Items selection',
    PURCHASE_CRITERIA_NOT_MET: 'Complete Purchase Items selection',
  },
};
export const location = {
  GOOGLE_DIRECTION_URL: 'https://www.google.com/maps/dir',
};

export const foodsArray = ['vegan', 'chicken', 'beef', 'seafood', 'vegetarian', 'halal', 'gluten-free', 'kosher'];
export const drinksArray = ['beer', 'wine', 'cocktail', 'non-alcoholic'];

export const default_country_codes = ['us'];

export const cartPoints = [
  {
    title: 'Redeemed Points',
    value: 0,
    tooltip: 'Points used to redeem item',
    isAvailable: true,
  },
  {
    title: 'Available Points',
    value: 0,
    tooltip: 'Points balance including redeemed points',
    isAvailable: true,
  },
  {
    title: 'Points Collected',
    value: 0,
    tooltip: 'Points added to balance after payment',
    isAvailable: false,
  },
];

export const defaultCartExpiryTime = 4 * 24 * 60 * 60 * 1000; // 4 days in milliseconds
export const cookieExpiryTime = 30 * 24 * 60 * 60; // 30 days in seconds

export enum GIFT_CARD_LINK {
  EXPIRE_LINK = 'expire',
  INVALID_LINK = 'invalid',
  VALID_LINK = 'valid',
}

export const defaultTiming = {
  start: '00:00:00',
  end: '23:59:00',
};
